<template>
  <base-template current-page="QuotesIndex">
    <router-view></router-view>
  </base-template>
</template>

<script>
import BaseTemplate from "../BaseTemplate";

export default {
  name: "QuotesIndex",
  components: { BaseTemplate },
};
</script>
